import React from "react";
import LandingPage from "@/pages/LandingPage";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <div className="App">
      <LandingPage />
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}
